// @ts-nocheck

import { colors } from '@lmc/common/constants'
import { theme } from '@lmc/ui-kit'
import { css, StyleSheet } from 'aphrodite/no-important'
import { capitalize, get } from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'

export default class BubbleTextInput extends React.Component {
  state = {
    width: null
  }

  handleChange = (e) => {
    const { formKey, onChange } = this.props
    const length = e.target.value.length ? e.target.value.length + 5 : 6
    this.setState({
      width: `${length}ch`
    })
    onChange({ key: formKey, value: e.target.value })
  }

  render() {
    const {
      formKey,
      inputColors = {},
      label,
      placeholder,
      style,
      values
    } = this.props

    const value = get(values, formKey) || ''

    let width
    if (this.state.width) {
      width = this.state.width
    } else if (value && value.length) {
      width = `${value.length + 5}ch`
    } else {
      width = '6ch'
    }

    const classes = StyleSheet.create({
      container: {
        display: 'flex',
        flexDirection: 'column',
        margin: '10px 5px 10px 5px'
      },
      input: {
        backgroundColor: inputColors.active || 'white',
        border: `1px solid ${colors.grey}`,
        borderRadius: 1000,
        color: inputColors.text,
        fontSize: 14,
        float: 'left',
        height: 26,
        padding: '2px 10px 2px 10px',
        marginTop: 2,
        textAlign: 'center',
        transition: 'border-color .15s ease',
        width,
        ':focus': {
          outline: 'none',
          border: '1px solid',
          borderColor: theme.color.status.primary
        },
        '::placeholder': {
          color: inputColors.text,
          opacity: 1
        },
        '::ms-input-placeholder': {
          color: inputColors.text
        },
        ...style
      },
      label: {
        fontSize: 11
      }
    })

    return (
      <div className={css(classes.container)}>
        <div className={css(classes.label)}>{capitalize(label)}</div>
        <input
          className={css(classes.input)}
          onChange={this.handleChange}
          placeholder={placeholder || '...'}
          value={value || ''}
        />
      </div>
    )
  }
}

BubbleTextInput.propTypes = {
  inputColors: PropTypes.object
}
